import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedVenueTag } from '../../../store/VenueTagReducer'
import { requiredRule } from '../../../utils/rules'
import AttachmentEditor from '../../AttachmentEditor'
import { Localizable } from '../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedVenueTag())

  useEffect(() => {
    if (!item) return
    form.setFieldsValue({ ...item, icon: undefined })
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Localizable.Input
        name="name"
        rules={[requiredRule()]}
        label={'Name'}
        max={20}
      />
      <AttachmentEditor
        dragger={{ fileTypes: ['picture'] }}
        formItem={{ name: 'icon', rules: [] }}
        image={{ width: 256, height: 256, aspect: 1 }}
      />
    </Form>
  )
}

export default Update
